/* Ren – tema-JS (inga beroenden) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => {
    const fmt = window.RenTheme?.moneyFormat || '{{amount_no_decimals}} kr';
    const n = cents / 100;
    const parts = {
      amount: n.toFixed(2).replace('.', ','),
      amount_no_decimals: Math.round(n).toLocaleString('sv-SE'),
      amount_with_comma_separator: n.toFixed(2).replace('.', ','),
      amount_no_decimals_with_comma_separator: Math.round(n).toLocaleString('sv-SE'),
      amount_with_space_separator: n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => parts[k] ?? parts.amount);
  };
  window.RenTheme = Object.assign(window.RenTheme || {}, { money });

  /* ---------- Scroll-reveal ---------- */
  function initReveal(scope) {
    const els = $$('[data-animate]', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reducedMotion() || !document.documentElement.classList.contains('animations-enabled')) {
      els.forEach((e) => e.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    els.forEach((e) => {
      const d = e.getAttribute('data-animate-delay');
      if (d) e.style.setProperty('--animate-delay', d + 's');
      io.observe(e);
    });
  }

  /* ---------- Header ---------- */
  function initHeader(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';
    const header = $('[data-site-header]', root);
    const toggle = $('[data-mobile-toggle]', root);
    const menu = $('[data-mobile-menu]', root);
    const syncOffset = () => {
      const h = Math.ceil(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--header-offset', h + 'px');
      if (root.classList.contains('header-root--transparent')) document.documentElement.style.setProperty('--header-fixed-offset', Math.ceil(root.getBoundingClientRect().height) + 'px');
    };
    const wrap = root.parentElement;
    if (wrap && wrap !== document.body) {
      wrap.classList.toggle('header-section--sticky', root.classList.contains('header-root--sticky'));
      wrap.classList.toggle('header-section--overlay', root.classList.contains('header-root--transparent'));
    }
    syncOffset();
    // Fäll ihop menyn till hamburgare om den inte får plats
    const inner = $('.header__inner', root);
    const fit = () => {
      if (!inner || window.innerWidth < 1024) { root.classList.remove('is-collapsed'); menu && menu.classList.toggle('mobile-menu--desktop', menu.dataset.desktop === '1'); return; }
      root.classList.remove('is-collapsed');
      const navs = $$('.header__nav', root);
      const cols = $$('.header__left, .header__center, .header__right', inner).filter((c) => c.getBoundingClientRect().width > 0).map((c) => c.getBoundingClientRect());
      const ib = inner.getBoundingClientRect();
      let overlap = false;
      for (let i = 1; i < cols.length; i++) if (cols[i].left < cols[i - 1].right + 8) overlap = true;
      if (cols.length && (cols[0].left < ib.left - 2 || cols[cols.length - 1].right > ib.right + 2)) overlap = true;
      const row2 = $('.header__row2 .header__nav', root);
      const wrap = root.dataset.overflow === 'wrap';
      const overflow = overlap || (!wrap && (navs.some((n) => n.scrollWidth > n.clientWidth + 2) || (row2 && row2.getBoundingClientRect().width > ib.width + 2)));
      if (overflow) { root.classList.add('is-collapsed'); menu && menu.classList.add('mobile-menu--desktop'); }
    };
    if (menu) menu.dataset.desktop = menu.classList.contains('mobile-menu--desktop') ? '1' : '0';
    let t; const refit = () => { clearTimeout(t); t = setTimeout(() => { fit(); syncOffset(); }, 60); };
    fit(); window.addEventListener('resize', refit); if (document.fonts) document.fonts.ready.then(fit);
    if (window.ResizeObserver) new ResizeObserver(syncOffset).observe(root);
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      if (header.classList.contains('header--transparent')) header.classList.toggle('is-solid', y > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (!toggle || !menu) return;
    let lastFocus = null;
    const open = () => {
      lastFocus = document.activeElement;
      const items = $$('.mobile-menu__item', menu);
      const step = reducedMotion() ? 0 : 40;
      items.forEach((el, i) => (el.style.transitionDelay = (reducedMotion() ? 0 : 80 + i * step) + 'ms'));
      $$('.mobile-menu__divider', menu).forEach((d) => (d.style.transitionDelay = reducedMotion() ? '0ms' : '300ms'));
      const card = $('.mobile-menu__card-wrap', menu); if (card) card.style.transitionDelay = reducedMotion() ? '0ms' : '350ms';
      menu.classList.add('is-open'); toggle.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
    };
    const close = () => {
      menu.classList.remove('is-open'); toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    toggle.addEventListener('click', () => (menu.classList.contains('is-open') ? close() : open()));
    $$('[data-mobile-close]', menu).forEach((b) => b.addEventListener('click', close));
    $$('a[href]', menu).forEach((a) => a.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
    window.addEventListener('resize', () => { if (window.innerWidth >= 1024 && !menu.classList.contains('mobile-menu--desktop') && menu.classList.contains('is-open')) close(); });
  }

  /* ---------- Meddelanderad ---------- */
  function initAnnouncement(scope) {
    $$('[data-announcement]', scope).forEach((bar) => {
      if (bar.dataset.init) return; bar.dataset.init = '1';
      const slides = $$('.announcement__slide', bar); if (slides.length < 2) return;
      let i = 0, timer; const interval = parseInt(bar.dataset.interval || '4000', 10);
      const go = (n) => { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); };
      const start = () => { if (!reducedMotion()) timer = setInterval(() => go(i + 1), interval); };
      const restart = () => { clearInterval(timer); start(); };
      $('[data-ann-prev]', bar)?.addEventListener('click', () => { go(i - 1); restart(); });
      $('[data-ann-next]', bar)?.addEventListener('click', () => { go(i + 1); restart(); });
      start();
    });
  }

  /* ---------- Hero ordväxlare ---------- */
  function initHero(section) {
    // "Följ videons format": läs formatet från videon själv (behövs för externa MP4-länkar)
    $$('[data-hero]', section).forEach((hero) => {
      [['.hero__media--desktop video', '--hero-ratio-d'], ['.hero__media--mobile video', '--hero-ratio-m']].forEach(([q, prop]) => {
        const v = $(q, hero);
        if (!v) return;
        const set = () => { if (v.videoWidth && v.videoHeight) hero.style.setProperty(prop, v.videoWidth + ' / ' + v.videoHeight); };
        set(); v.addEventListener('loadedmetadata', set);
      });
    });
    const rot = $('[data-hero-rotator]', section);
    if (!rot || rot.dataset.init) return;
    rot.dataset.init = '1';
    const words = $$('.hero__word', rot);
    if (words.length < 2) { words[0]?.classList.add('is-active'); return; }
    let i = 0;
    words[0].classList.add('is-active');
    const interval = parseInt(rot.dataset.interval || '3000', 10);
    if (reducedMotion()) return;
    setInterval(() => {
      const cur = words[i]; i = (i + 1) % words.length; const next = words[i];
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      next.classList.remove('is-leaving'); next.classList.add('is-active');
      setTimeout(() => cur.classList.remove('is-leaving'), 400);
    }, interval);
  }

  /* ---------- Karusellprickar (mobil) ---------- */
  function initSnapDots(scope) {
    $$('[data-snap-dots]', scope).forEach((row) => {
      if (row.dataset.dotsInit) return; row.dataset.dotsInit = '1';
      const items = Array.from(row.children); if (items.length < 2) return;
      const dots = document.createElement('div'); dots.className = 'dots dots--light snap-dots';
      const pad = () => parseFloat(getComputedStyle(row).paddingLeft) || 0;
      const isCarousel = () => getComputedStyle(row).overflowX !== 'visible';
      let active = 0, hold = () => {};
      const btns = items.map((it, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'dots__dot'; b.setAttribute('aria-label', String(i + 1));
        b.addEventListener('click', () => { hold(); go(i); });
        dots.appendChild(b); return b;
      });
      const set = (i) => { active = i; btns.forEach((b, k) => b.classList.toggle('is-active', k === i)); items.forEach((it, k) => it.classList.toggle('is-snap-active', k === i)); };
      const go = (i) => { row.scrollTo({ left: items[i].offsetLeft - row.offsetLeft - pad(), behavior: reducedMotion() ? 'auto' : 'smooth' }); set(i); };
      const sync = () => {
        const edge = row.getBoundingClientRect().left + pad(); let best = 0, dist = Infinity;
        items.forEach((it, i) => { const d = Math.abs(it.getBoundingClientRect().left - edge); if (d < dist) { dist = d; best = i; } });
        if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 4) best = items.length - 1;
        if (row.scrollLeft <= 4) best = 0;
        set(best);
      };
      row.insertAdjacentElement('afterend', dots);
      row.classList.add('has-snap-dots'); set(0);
      items.forEach((it, i) => it.addEventListener('mouseenter', () => { if (!isCarousel()) { hold(); set(i); } }));
      let t; row.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(sync, 90); }, { passive: true });
      const auto = parseInt(row.dataset.snapAuto || '0', 10);
      if (auto > 0 && !reducedMotion()) {
        let visible = false, paused = false, resume;
        hold = () => { paused = true; clearTimeout(resume); resume = setTimeout(() => { paused = false; }, 6000); };
        ['touchstart', 'pointerdown', 'wheel'].forEach((ev) => row.addEventListener(ev, hold, { passive: true }));
        if ('IntersectionObserver' in window) new IntersectionObserver((es) => { visible = es[0].isIntersecting; }, { threshold: 0.4 }).observe(row); else visible = true;
        setInterval(() => { if (!visible || paused || document.hidden) return; const n = (active + 1) % items.length; if (isCarousel()) go(n); else set(n); }, auto);
      }
    });
  }

  /* ---------- Galleri-slider ---------- */
  function initGallery(section) {
    const g = $('[data-gallery]', section); if (!g || g.dataset.init) return; g.dataset.init = '1';
    const slides = $$('.gallery__slide', g); const dots = $$('.dots__dot', g.closest('.shopify-section') || g.parentElement);
    if (!slides.length) return;
    let i = 0, timer;
    const go = (n) => { slides[i].classList.remove('is-active'); dots[i]?.classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); dots[i]?.classList.add('is-active'); };
    const auto = parseInt(g.dataset.autoplay || '0', 10);
    const start = () => { if (auto > 0 && !reducedMotion()) timer = setInterval(() => go(i + 1), auto); };
    const stop = () => clearInterval(timer);
    g.addEventListener('click', () => { stop(); go(i + 1); start(); });
    dots.forEach((d, n) => d.addEventListener('click', (e) => { e.stopPropagation(); stop(); go(n); start(); }));
    let sx = 0; g.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
    g.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { stop(); go(dx < 0 ? i + 1 : i - 1); start(); } });
    start();
  }

  /* ---------- Formel (rader → bild) ---------- */
  function initFormula(scope) {
    $$('.formula', scope).forEach((section) => {
      if (section.dataset.formulaInit) return; section.dataset.formulaInit = '1';
      const rows = $$('[data-formula-row]', section); if (!rows.length) return;
      const imgs = $$('[data-formula-image]', section); const title = $('[data-formula-title]', section); const text = $('[data-formula-text]', section); const link = $('[data-formula-link]', section);
      const activate = (row) => {
        rows.forEach((r) => r.classList.toggle('is-active', r === row));
        const idx = row.dataset.formulaRow;
        const has = imgs.some((im) => im.dataset.formulaImage === idx);
        imgs.forEach((im) => im.classList.toggle('is-active', has ? im.dataset.formulaImage === idx : im.dataset.formulaImage === 'base' || (im === imgs[0] && !imgs.some((x) => x.dataset.formulaImage === 'base'))));
        if (title && row.dataset.title) title.textContent = row.dataset.title;
        if (text && row.dataset.text) text.textContent = row.dataset.text;
        if (link) { if (row.dataset.url) { link.href = row.dataset.url; link.hidden = false; } else link.hidden = true; }
      };
      rows.forEach((r) => { r.addEventListener('mouseenter', () => activate(r)); r.addEventListener('click', () => activate(r)); r.addEventListener('focus', () => activate(r)); });
      activate(rows[0]);
    });
  }

  /* ---------- Dagar (tabbar + bild) ---------- */
  function initDays(section) {
    const root = $('[data-days]', section); if (!root || root.dataset.init) return; root.dataset.init = '1';
    const items = $$('[data-days-item]', root); const panels = $$('[data-days-panel]', root); const cur = $('[data-days-current]', root);
    const interval = parseInt(root.dataset.autoplay || '0', 10);
    root.style.setProperty('--days-interval', interval + 'ms');
    let idx = 0, timer = null, paused = false;
    const go = (n) => {
      idx = (n + items.length) % items.length; const key = items[idx].dataset.daysItem;
      items.forEach((it) => it.classList.toggle('is-active', it.dataset.daysItem === key));
      panels.forEach((p) => p.classList.toggle('is-active', p.dataset.daysPanel === key));
      if (cur) cur.textContent = String(idx + 1).padStart(2, '0');
      // starta om förloppsstrecket
      const bar = $('.days__progress-bar', items[idx]); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      restart();
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const restart = () => { stop(); if (interval > 0 && !reducedMotion() && !paused) timer = setInterval(() => go(idx + 1), interval); };
    items.forEach((it, n) => { it.addEventListener('click', () => go(n)); it.addEventListener('mouseenter', () => { if (n !== idx) go(n); }); });
    $('[data-days-prev]', root)?.addEventListener('click', () => go(idx - 1));
    $('[data-days-next]', root)?.addEventListener('click', () => go(idx + 1));
    const desk = $('.days__desktop', root) || root;
    desk.addEventListener('mouseenter', () => { paused = true; root.classList.add('is-paused'); stop(); });
    desk.addEventListener('mouseleave', () => { paused = false; root.classList.remove('is-paused'); restart(); });
    // pausa när sektionen inte syns
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { if (en.isIntersecting) restart(); else stop(); }).observe(root);
    if (items.length) go(0);
    // Mobil slider
    const slider = $('[data-days-slider]', section); const dots = $$('.dots__dot', section);
    if (slider && dots.length) {
      const cards = $$('.days__card', slider);
      const upd = () => { const c = slider.scrollLeft + slider.clientWidth / 2; let best = 0, bd = 1e9; cards.forEach((card, n) => { const d = Math.abs(card.offsetLeft + card.offsetWidth / 2 - c); if (d < bd) { bd = d; best = n; } }); dots.forEach((d, n) => d.classList.toggle('is-active', n === best)); };
      slider.addEventListener('scroll', upd, { passive: true }); upd();
      dots.forEach((d, n) => d.addEventListener('click', () => cards[n]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })));
    }
  }

  /* ---------- Marquee: duplicera innehåll ---------- */
  function initMarquee(section) {
    $$('[data-marquee]', section).forEach((track) => {
      if (track.dataset.init) return; track.dataset.init = '1';
      const group = track.firstElementChild; if (!group) return;
      const need = Math.ceil((window.innerWidth * 2) / Math.max(group.offsetWidth, 1));
      for (let i = 0; i < Math.max(1, need); i++) track.appendChild(group.cloneNode(true));
    });
  }

  /* ---------- Cart drawer ---------- */
  const Cart = {
    el: null,
    init() {
      this.el = $('[data-cart-drawer]'); if (!this.el) return;
      $$('[data-cart-close]', this.el).forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-cart-open]');
        if (t && document.documentElement.dataset.cartType === 'drawer') { e.preventDefault(); this.open(); }
      });
      this.bind();
      document.addEventListener('cart:updated', (e) => this.render(e.detail?.sections));
    },
    open() { if (!this.el) return; this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false'); document.body.classList.add('is-locked'); $('[data-cart-close]', this.el)?.focus(); },
    close() { if (!this.el) return; this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('is-locked'); },
    bind() {
      if (!this.el) return;
      $$('[data-line-change]', this.el).forEach((b) => b.addEventListener('click', () => this.change(b.dataset.lineKey, parseInt(b.dataset.lineChange, 10))));
      $$('[data-line-qty]', this.el).forEach((inp) => inp.addEventListener('change', () => this.change(inp.dataset.lineKey, parseInt(inp.value, 10), true)));
      $$('[data-line-remove]', this.el).forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); this.change(b.dataset.lineKey, 0, true); }));
    },
    async change(key, qty, absolute) {
      if (!key) return;
      this.el.classList.add('is-loading');
      const inp = $(`[data-line-qty][data-line-key="${key}"]`, this.el);
      const cur = inp ? parseInt(inp.value, 10) : 1;
      const q = absolute ? qty : Math.max(0, cur + qty);
      try {
        const res = await fetch(window.RenTheme.routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q, sections: 'cart-drawer,cart-icon-bubble' }) });
        const data = await res.json();
        this.render(data.sections);
      } catch (err) { console.error(err); }
      this.el.classList.remove('is-loading');
    },
    render(sections) {
      if (!sections) return this.refresh();
      if (sections['cart-drawer']) {
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const fresh = $('[data-cart-drawer-content]', html); const cur = $('[data-cart-drawer-content]', this.el);
        if (fresh && cur) cur.replaceWith(fresh);
        this.bind();
      }
      if (sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const count = $('[data-cart-count]', html)?.dataset.count ?? '0';
        $$('[data-cart-count]').forEach((c) => { c.dataset.count = count; c.textContent = count; });
      }
    },
    async refresh() {
      try { const res = await fetch(`${window.RenTheme.routes.cart_url}?sections=cart-drawer,cart-icon-bubble`); this.render(await res.json()); } catch (e) { console.error(e); }
    },
    async add(body, btn) {
      btn?.classList.add('is-loading'); btn && (btn.disabled = true);
      try {
        const payload = Object.assign({}, body, { sections: 'cart-drawer,cart-icon-bubble' });
        const res = await fetch(window.RenTheme.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Kunde inte lägga i varukorgen');
        this.render(data.sections);
        if (document.documentElement.dataset.cartType === 'drawer') this.open(); else window.location.href = window.RenTheme.routes.cart_url;
        return data;
      } catch (err) { throw err; } finally { btn?.classList.remove('is-loading'); btn && (btn.disabled = false); }
    }
  };
  window.RenTheme.Cart = Cart;

  /* ---------- Produktform ---------- */
  function initProduct(section) {
    const root = $('[data-product]', section); if (!root || root.dataset.init) return; root.dataset.init = '1';
    const product = JSON.parse($('[data-product-json]', root)?.textContent || 'null'); if (!product) return;
    const form = $('form.product__form', root); const idInput = $('input[name="id"]', form);
    const optionInputs = () => $$('[data-option-index]', form);
    const priceMain = $('[data-price-main]', root); const priceCompare = $('[data-price-compare]', root); const priceSub = $('[data-price-sub]', root); const unit = $('[data-price-unit]', root);
    const atc = $('[data-atc]', root); const atcLabel = $('[data-atc-label]', atc); const stickyAtc = $('[data-sticky-atc]', section);
    const errorEl = $('[data-form-error]', root);
    const perDayDivisor = parseInt(root.dataset.perDay || '0', 10);

    const selectedOptions = () => { const opts = []; optionInputs().forEach((inp) => { if (inp.type === 'radio') { if (inp.checked) opts[parseInt(inp.dataset.optionIndex, 10)] = inp.value; } else opts[parseInt(inp.dataset.optionIndex, 10)] = inp.value; }); return opts; };
    const findVariant = () => { const opts = selectedOptions(); return product.variants.find((v) => v.options.every((o, i) => o === opts[i])); };
    const currentPlan = () => { const inp = $('input[name="selling_plan"]:checked', form); return inp && inp.value ? inp.value : null; };

    function planPrice(variant) {
      const planId = currentPlan();
      if (!planId || !variant.selling_plan_allocations) return null;
      return variant.selling_plan_allocations.find((a) => String(a.selling_plan_id) === String(planId)) || null;
    }
    function renderPrice(variant) {
      if (!variant) return;
      const alloc = planPrice(variant);
      const price = alloc ? alloc.price : variant.price;
      const compare = alloc ? (alloc.compare_at_price || variant.price) : variant.compare_at_price;
      const fmt = (c) => (perDayDivisor ? money(Math.round(c / perDayDivisor)) + root.dataset.perDayLabel : money(c));
      if (priceMain) priceMain.textContent = fmt(price);
      if (priceCompare) { if (compare && compare > price) { priceCompare.textContent = fmt(compare); priceCompare.hidden = false; } else priceCompare.hidden = true; }
      if (priceSub) priceSub.textContent = money(price);
      if (unit && variant.unit_price) unit.textContent = money(variant.unit_price) + ' / ' + (variant.unit_price_measurement?.reference_value || '') + (variant.unit_price_measurement?.reference_unit || '');
      $$('[data-plan-price]', root).forEach((el) => { const pid = el.dataset.planPrice; const a = pid ? variant.selling_plan_allocations?.find((x) => String(x.selling_plan_id) === pid) : null; const p = a ? a.price : variant.price; const c = a ? (a.compare_at_price || variant.price) : variant.compare_at_price; el.innerHTML = money(p) + (c && c > p ? `<s>${money(c)}</s>` : ''); });
      $$('[data-sticky-price]', section).forEach((el) => (el.innerHTML = money(price) + (compare && compare > price ? `<s>${money(compare)}</s>` : '')));
    }
    function renderAvailability(variant) {
      if (!atc) return;
      if (!variant) { atc.disabled = true; atcLabel.textContent = root.dataset.textUnavailable; }
      else if (!variant.available) { atc.disabled = true; atcLabel.textContent = root.dataset.textSoldOut; }
      else { atc.disabled = false; atcLabel.textContent = root.dataset.textAtc; }
      $$('[data-sticky-atc-btn]', section).forEach((b) => (b.disabled = atc.disabled));
    }
    function renderMedia(variant) {
      if (!variant || !variant.featured_media) return;
      const layer = $(`[data-media-id="${variant.featured_media.id}"]`, section); if (layer) showMedia(layer.dataset.mediaIndex);
    }
    function updateUrl(variant) { if (!variant || !history.replaceState) return; const u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u); }
    function update() {
      const v = findVariant();
      if (v) { idInput.value = v.id; renderMedia(v); updateUrl(v); }
      renderPrice(v); renderAvailability(v);
      $$('[data-sticky-title]', section).forEach((el) => (el.textContent = product.title + (v && v.title !== 'Default Title' ? ' | ' + v.title : '')));
      // markera otillgängliga kombinationer
      const opts = selectedOptions();
      optionInputs().forEach((inp) => { if (inp.type !== 'radio') return; const i = parseInt(inp.dataset.optionIndex, 10); const test = opts.slice(); test[i] = inp.value; const ok = product.variants.some((va) => va.available && va.options.every((o, k) => k === i ? o === inp.value : (k < i ? o === test[k] : true))); inp.nextElementSibling?.classList.toggle('is-unavailable', !ok); });
    }
    optionInputs().forEach((inp) => inp.addEventListener('change', update));
    $$('input[name="selling_plan"]', form).forEach((inp) => inp.addEventListener('change', () => { $$('.plan', form).forEach((p) => p.classList.toggle('is-active', $('input[name="selling_plan"]', p) === inp)); update(); }));
    $$('[data-plan-freq]', form).forEach((sel) => sel.addEventListener('change', () => { const plan = sel.closest('.plan'); const radio = $('input[name="selling_plan"]', plan); if (radio) { radio.value = sel.value; update(); } }));

    // Media
    const layers = $$('[data-media-index]', section); const thumbs = $$('[data-thumb-index]', section); const dots = $$('[data-media-dot]', section);
    function showMedia(idx) {
      layers.forEach((l) => { const on = l.dataset.mediaIndex === String(idx); l.classList.toggle('is-active', on); const v = $('video', l); if (v) { on ? v.play().catch(() => {}) : v.pause(); } });
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumbIndex === String(idx)));
      dots.forEach((d) => d.classList.toggle('is-active', d.dataset.mediaDot === String(idx)));
      thumbs.find((t) => t.dataset.thumbIndex === String(idx))?.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumbIndex)));
    dots.forEach((d) => d.addEventListener('click', () => showMedia(d.dataset.mediaDot)));
    const stage = $('[data-media-stage]', section);
    if (stage) { let sx = 0; stage.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true }); stage.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { const cur = layers.findIndex((l) => l.classList.contains('is-active')); showMedia((cur + (dx < 0 ? 1 : -1) + layers.length) % layers.length); } }); }
    $('[data-thumb-prev]', section)?.addEventListener('click', () => $('.product__thumbs', section).scrollBy({ left: -200, behavior: 'smooth' }));
    $('[data-thumb-next]', section)?.addEventListener('click', () => $('.product__thumbs', section).scrollBy({ left: 200, behavior: 'smooth' }));

    // Kvantitet
    $$('[data-qty-change]', section).forEach((b) => b.addEventListener('click', () => { const inp = $('[data-qty-input]', b.closest('.qty')); const n = Math.max(1, parseInt(inp.value || '1', 10) + parseInt(b.dataset.qtyChange, 10)); inp.value = n; $$('[data-qty-input]', section).forEach((i) => (i.value = n)); }));
    $$('[data-qty-input]', section).forEach((inp) => inp.addEventListener('change', () => $$('[data-qty-input]', section).forEach((i) => (i.value = Math.max(1, parseInt(inp.value || '1', 10))))));

    // ATC
    async function submit(btn) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      const qty = parseInt($('[data-qty-input]', section)?.value || '1', 10);
      const body = { items: [{ id: parseInt(idInput.value, 10), quantity: qty }] };
      const plan = currentPlan(); if (plan) body.items[0].selling_plan = parseInt(plan, 10);
      const props = {}; $$('[name^="properties["]', form).forEach((p) => { const k = p.name.slice(11, -1); if (p.type === 'checkbox' ? p.checked : p.value) props[k] = p.value; }); if (Object.keys(props).length) body.items[0].properties = props;
      try { await Cart.add(body, btn); } catch (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } }
    }
    form?.addEventListener('submit', (e) => { e.preventDefault(); submit(atc); });
    $$('[data-sticky-atc-btn]', section).forEach((b) => b.addEventListener('click', () => submit(b)));

    // Sticky ATC
    if (stickyAtc && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => stickyAtc.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(atc);
    }
    // Nedräkning leverans
    $$('[data-countdown]', section).forEach((el) => {
      const cutoff = parseInt(el.dataset.countdown || '14', 10);
      const tick = () => { const now = new Date(); const t = new Date(now); t.setHours(cutoff, 0, 0, 0); if (t <= now) t.setDate(t.getDate() + 1); const d = Math.floor((t - now) / 1000); el.textContent = `${String(Math.floor(d / 3600)).padStart(2, '0')}:${String(Math.floor((d % 3600) / 60)).padStart(2, '0')}:${String(d % 60).padStart(2, '0')}`; };
      tick(); setInterval(tick, 1000);
    });
    update();
  }

  /* ---------- Snabbköp på produktkort ---------- */
  function initQuickAdd(scope) {
    $$('[data-quick-add]', scope).forEach((btn) => {
      if (btn.dataset.init) return; btn.dataset.init = '1';
      btn.addEventListener('click', async (e) => { e.preventDefault(); try { await Cart.add({ items: [{ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }] }, btn); } catch (err) { alert(err.message); } });
    });
  }

  /* ---------- Bundle-byggare ---------- */
  function initBundle(section) {
    const root = $('[data-bundle]', section); if (!root || root.dataset.init) return; root.dataset.init = '1';
    const items = $$('[data-bundle-item]', root); const totalEl = $('[data-bundle-total]', root); const compareEl = $('[data-bundle-compare]', root); const hint = $('[data-bundle-hint]', root); const btn = $('[data-bundle-add]', root); const summary = $('[data-bundle-summary]', root); const err = $('[data-bundle-error]', root);
    const toggles = $$('[data-bundle-mode]', root); let mode = toggles.find((t) => t.classList.contains('is-active'))?.dataset.bundleMode || 'onetime';
    const discountPct = parseFloat(root.dataset.subDiscount || '0');
    const state = new Map();
    function price(item) { const base = parseInt(item.dataset.price, 10); const sub = parseInt(item.dataset.subPrice || '0', 10); return mode === 'subscription' ? (sub || Math.round(base * (1 - discountPct / 100))) : base; }
    function render() {
      let total = 0, compare = 0, count = 0;
      items.forEach((item) => { const q = state.get(item) || 0; count += q; total += q * price(item); compare += q * parseInt(item.dataset.price, 10); item.classList.toggle('has-qty', q > 0); $('[data-bundle-qty]', item).textContent = q; $('[data-bundle-item-price]', item).textContent = money(price(item)); });
      totalEl.textContent = money(total);
      if (compareEl) { compareEl.textContent = compare > total ? money(compare) : ''; compareEl.hidden = compare <= total; }
      if (hint) hint.textContent = count ? root.dataset.textCount.replace('[antal]', count) : root.dataset.textEmpty;
      btn.disabled = count === 0; summary.classList.toggle('is-empty', count === 0);
    }
    items.forEach((item) => { $$('[data-bundle-change]', item).forEach((b) => b.addEventListener('click', () => { state.set(item, Math.max(0, (state.get(item) || 0) + parseInt(b.dataset.bundleChange, 10))); render(); })); });
    toggles.forEach((t) => t.addEventListener('click', () => { toggles.forEach((x) => x.classList.toggle('is-active', x === t)); mode = t.dataset.bundleMode; render(); }));
    btn.addEventListener('click', async () => {
      const lines = []; items.forEach((item) => { const q = state.get(item) || 0; if (!q) return; const line = { id: parseInt(item.dataset.variantId, 10), quantity: q }; if (mode === 'subscription' && item.dataset.planId) line.selling_plan = parseInt(item.dataset.planId, 10); lines.push(line); });
      if (!lines.length) return; err.classList.remove('is-visible');
      try { await Cart.add({ items: lines }, btn); } catch (e) { err.textContent = e.message; err.classList.add('is-visible'); }
    });
    render();
  }

  /* ---------- Localization form ---------- */
  function initLocalization() {
    $$('[data-localization-select]').forEach((sel) => sel.addEventListener('change', () => { const form = sel.closest('form'); $('input[name="locale_code"], input[name="country_code"]', form) && ($(`input[name="${sel.dataset.localizationSelect}"]`, form).value = sel.value); form.submit(); }));
  }

  /* ---------- Init allt ---------- */
  function initSection(section) {
    initReveal(section); initAnnouncement(section); initHero(section); initSnapDots(section); initGallery(section); initFormula(section); initDays(section); initMarquee(section); initProduct(section); initBundle(section); initQuickAdd(section);
  }
  function initAll() {
    $$('[data-header-root]').forEach(initHeader);
    Cart.init(); initLocalization();
    initSection(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', (e) => { const s = e.target; $$('[data-header-root]', s).forEach(initHeader); if (s.matches('[data-header-root]')) initHeader(s); initSection(s); Cart.init(); });
  document.addEventListener('shopify:section:select', (e) => { if ($('[data-cart-drawer]', e.target)) Cart.open(); });
  document.addEventListener('shopify:section:deselect', (e) => { if ($('[data-cart-drawer]', e.target)) Cart.close(); });
})();
